import STATUS from "@/status";
import OPTIONS from "@/options";

export default {
  /**
   * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
   * MAKE SURE THIS FLAG IS ONLY SET TO TRUE WHEN GOING TO PRODUCTION
   * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
   *
   * For any changes to firebase imports or dev & production differentiation
   * make sure to update UserCreate.vue component as well
   * (since a separate firebase instance is needed there)
   */
  // PRODUCTION: (process.env.NODE_ENV === 'production'),
  PRODUCTION: false,

  // CLUB_URL: (process.env.NODE_ENV === 'production') ? 'https://club.dukehorlogerie.com/' : 'http://localhost:8080/',
  // CLUB_URL: "https://v1.duke.jymbe.com/",
  // CLUB_URL: "https://v2.duke.jymbe.com/",
  CLUB_URL: "http://localhost:8080/",
  STRIPE_LIVE_MODE: false,
  // STRIPE_LIVE_MODE: (process.env.NODE_ENV === 'production'),

  URL_PREFIX: "",
  // URL_PREFIX: "/club",
  //*************************************************************** */

  //----- Status (imported from status.js) -------------------------------------------

  STATUS,

  //----- Dropdown Options (imported from options.js) -------------------------------------------
  OPTIONS,

  //----- USER -----------------------------------------------------------------------

  // user types
  TYPE_INDEX: ["Member", "Admin", "Super Admin"],
  TYPE: {
    MEMBER: 0,
    ADMIN: 2,
    SUPER_ADMIN: 3,
  },

  //----- LIBRARY -----------------------------------------------------------------------

  // library types
  LIBRARY_TYPE_INDEX: ["Positive Marker", "Negative Marker", "Animal", "Plant", "Place", "People", "Document", "Location", "Other"],
  LIBRARY_TYPE: {
    POSITIVE: 0,
    NEGATIVE: 1,
    ANIMAL: 2,
    PLANT: 3,
    PLACE: 4,
    PEOPLE: 5,
    DOCUMENT: 6,
    LOCATION: 7,
    OTHER: 8,
  },

  // library types fa icons
  LIBRARY_TYPE_FA_ICONS: [
    "Positive Marker",
    "Negative Marker",
    "fa-elephant",
    "fa-tree-alt",
    "fa-building",
    "fa-users",
    "fa-file",
    "fa-map-marker",
    "Other",
  ],

  // library item status
  LIBRARY_STATUS_INDEX: ["Unpublished", "Published", "Archived", "Featured"],
  LIBRARY_STATUS: {
    UNPUBLISHED: 0,
    PUBLISHED: 1,
    ARCHIVED: 2,
    FEATURED: 3,
  },
  LIBRARY_STATUS_COLORS: ["badge-warning", "badge-success", "badge-danger", "badge-info"],

  //----- ANIMALS -----------------------------------------------------------------------
  LIBRARY_ANIMAL_CLASS_INDEX: ["Mammal", "Bird", "Reptile", "Amphibian", "Fish", "Insect"],
  LIBRARY_ANIMAL_CLASS: {
    MAMMAL: 0,
    BIRD: 1,
    REPTILE: 2,
    AMPHIBIAN: 3,
    FISH: 4,
    INSECT: 5,
  },

  //----- PLACES -----------------------------------------------------------------------
  LIBRARY_PLACE_CLASS_INDEX: [
    "Nature",
    "Commerce & Urban",
    "Cultural & Historical",
    // "Monuments & Landmarks",
    "Activities & Adventures",
    "Events & Experiences",
  ],
  LIBRARY_PLACE_CLASS_SHORT_INDEX: ["Nature", "Commerce", "Cultural", "Activities", "Events"],
  LIBRARY_PLACE_CLASS: {
    NATURE: 0,
    COMMERCE: 1,
    CULTURAL: 2,
    // MONUMENTS: 3,
    ACTIVITY: 3,
    EVENT: 4,
  },

  //----- PLANTS -----------------------------------------------------------------------
  LIBRARY_PLANT_CLASS_INDEX: ["Trees", "Flowers", "Shrubs", "Grasses", "Succulents"],
  LIBRARY_PLANT_CLASS: {
    TREES: 0,
    FLOWERS: 1,
    SHRUBS: 2,
    GRASSES: 3,
    SUCCULENTS: 4,
  },

  //----- PEOPLE -----------------------------------------------------------------------
  LIBRARY_PEOPLE_CLASS_INDEX: ["Individual", "Group"],
  LIBRARY_PEOPLE_CLASS: {
    INDIVIDUAL: 0,
    GROUP: 1,
  },

  //----- LOCATIONS -----------------------------------------------------------------------
  LIBRARY_LOCATION_CLASS_INDEX: ["Country", "City/Region"],
  LIBRARY_LOCATION_CLASS: {
    COUNTRY: 0,
    CITY: 1,
    // REGION: 2,
  },

  //----- DOCUMENTS -----------------------------------------------------------------------
  LIBRARY_DOCUMENT_CLASS_INDEX: ["Gallery", "PDF"],
  LIBRARY_DOCUMENT_CLASS: {
    GALLERY: 0,
    PDF: 1,
  },

  //----- MARKERS -----------------------------------------------------------------------
  MARKERS_TYPE_INDEX: ["Positive Marker", "Negative Marker", "Animal", "Plant", "Place", "Document", "Other"],
  MARKERS_TYPE: {
    POSITIVE: 0,
    NEGATIVE: 1,
    ANIMAL: 2,
    PLANT: 3,
    PLACE: 4,
    DOCUMENT: 5,
    OTHER: 6,
  },

  //----- HISTORY/NOTIFICATIONS -----------------------------------------------------------------------

  // types of history events
  HISTORY_EVENTS: {
    ANIMAL_CREATE: "animal_created",
    ANIMAL_EDIT: "animal_edited",
    MARKER_PLACED: "marker_placed",
  },

  //----- UTILITIES ------------------------------------------------------------------

  // covert any array into an options array. each entry is an array item with an added value field from index
  getFormattedOptionsArray: function (input) {
    if (!input || !Array.isArray(input)) {
      console.log("getFormattedOptionsArray: CANNOT FORMAT OBJECT");
      console.log(input);
      return [];
    }
    var array = [];
    for (const [index, value] of input.entries()) {
      array.push({ value: index, text: value });
    }
    return array;
  },
  getFormattedBoolOptionsArray: function (input) {
    var array = [];
    //first item of given array is defined as true
    //TODO: change order: 0 for false
    array.push({ value: true, text: input[0] });
    array.push({ value: false, text: input[1] });
    return array;
  },

  // get a js Date from firestore timestamp
  getDateFromTimestamp: function (timestamp) {
    if (!timestamp) return null;
    return new Date(timestamp.seconds * 1000);
  },

  // get a js Date from milliseconds
  getDateStringFromMillis: function (millis) {
    if (!millis) return "-";
    let date = new Date(millis);
    // format: DD/MM/YYYYY
    return date.toLocaleDateString("fr-FR");
  },
  getTrimmedId(complete_id) {
    if (!complete_id) return "";
    return complete_id.substring(0, 12);
  },
  getTrimmedCoord(coord) {
    if (!coord) return "";
    let string = "" + coord;
    return string.substring(0, 8);
  },
  isInt(value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
  },
  isArrayOfObjects(val) {
    return Array.isArray(val) && val.length > 0 && val.every((v) => v && typeof v === "object" && !Array.isArray(v));
  },
  isArrayOfPrimitives(val) {
    return Array.isArray(val) && val.length > 0 && val.every((v) => typeof v !== "object");
  },
  isStringArray(val) {
    return Array.isArray(val) && typeof val[0] === "string";
  },
  isObjectArray(val) {
    return Array.isArray(val) && typeof val[0] === "object" && val[0] !== null;
  },

  //----- STORE -----------------------------------------------------------------------

  // store modes (states)
  MODE: {
    DEFAULT: 0,
    BUY: 1,
    LOADING: 2,
    ERROR: 3,
  },

  //----- OBJECT MODELS --------------------------------------------------------------

  //USER OBJECT
  USER: {
    firstName: "",
    lastName: "",
  },

  ANIMAL: {
    //meta
    categoryId: "",
    categoryName: "",
    type: 2,
    class: -1,
    status: 0,
    published: 1, // change to active
    // active: true,
    featured: 0,
    marker_show: 0,
    marker_duration: "0",
    // basic info
    name: "",
    nameLatin: "",
    nameScientific: "",
    ic: "",
    textShort: "",
    text: "",
    //stats
    // "additional_info": {
    species: "",
    lifespan: "",
    height: "",
    weight: "",
    diet: "",
    groupSize: "",
    gestPeriod: "",
    atBirth: "",
    dailyWater: "",
    dailyFood: "",
    speedWalk: "",
    rangeComm: "",
    sleepDuration: "",
    conservation: "",
    // }
    key_features: [""],
    visitor_tips: [""],
    interesting_facts: [""],
    // history
    createdBy: "",
    cratedOn: new Date(),
    modifiedOn: new Date(),
  },

  PLACE: {},

  //WATCH CATALOG OBJECT
  WATCH_MODEL: {
    name: "",
    active: true,
    text: "",
    color: "",
    price: 0,
    releaseDate: 2022,
    edition: "", //e.g. "1 of 8"
    status: STATUS.WATCH_MODEL_AVAILABILITY.BUY,

    en: {
      text: "",
      color: "",
      cooperation: "",
      limited: 8,
      movement: "",
      complications: "",
      dial: "",
      case: "",
      tourbillon: "",
      winding: "",
      nbOfJewels: "",
      frequency: "",
      powerReserve: "",
      diameter: "",
      thickness: "",
      finishingMovement: "",
      material: "",
      appliques: "",
      signaturePlate: "",
      indexRing: "",
      finishingDial: "",
      bezel: "",
      lugs: "",
      middleCase: "",
      container: "",
      caseBack: "",
      crown: "",
      finishingCase: "",
    },
    assets: {
      front: "",
      side: "",
      case: "",
      movement: "",
      dial: "",
      render: "",
      logo: "",
      warranty_en: "",
      warranty_fr: "",
    },
  },

  //WATCH OBJECT
  WATCH: {
    status: 1,
    userId: "",
    modelId: "",
    paymentId: "",
    serial: "",
    //history
    createdBy: "",
    createdOn: new Date(),
    modifiedOn: new Date(),

    //delivery
    delivery: null,
  },

  //SERVICE CATALOG OBJECT
  SERVICE_CATALOG: {
    name: "",
    active: true,
    text: "",
    price: 0,
    createdOn: new Date(),
  },

  //SERVICE(APPOINTMENT) OBJECT
  APPOINTMENT: {
    status: STATUS.APPOINTMENT_STATUS.UNCONFIRMED,
    watchId: "",
    paymentId: "",
    modelId: "",
    serviceId: "",
    userId: "",
    modelName: "",
    serviceName: "",
    servicePrice: "",
    date: new Date(),
    createdOn: new Date(),
    modifiedOn: new Date(),
    info: "",

    /**
     * currently handled via info field => ready for admin
     * when time these fields can provide additional (optional) info
     */
    estimatedFinishDate: new Date().toISOString().substring(0, 10),
    dispatchDate: new Date().toISOString().substring(0, 10),
    deliveryDate: new Date().toISOString().substring(0, 10),
    deliveryCarrier: "",
    deliveryTrackingId: "",

    /**
     * possible additional info (unused so far)
     */
    // customerDsipatchDate: new Date(),
    // customerTrackingId: "",
    // receivedOn: new Date(),
    // finishedOn: new Date(),
    // deliveredOn: new Date(),
  },

  //WARRANTY OBJECT
  // WARRANTY: {
  //   status: 0,
  //   watchId: "",
  //   name: "",
  //   start: new Date().toISOString().substring(0, 10),
  //   end: "",
  //   duration: ""
  // },

  //NEWS ARTICLE OBJECT
  NEWS_ARTICLE: {
    type: 0, //category
    category: 0,
    status: 0,
    title: "",
    text: "",
    published: false,
    permissions: ["admin"],
    hasPdf: false,
    pdfUrl: "",
    customCover: false,
    hasCoverImage: false,
    coverUrl: "",
    //createdOn: firebase.firestore FieldValue.serverTimestamp(),
    //publishedOn: firebase.firestore.FieldValue.serverTimestamp()
  },

  //NOTIFICATION OBJECT
  NOTIFICATION: {
    category: "",
    date: new Date(),
    text: "",
    isRead: false,
    readOn: new Date(),
    userId: "",
  },

  //----- COUNTRIES -----------------------------------------------------------------------

  COUNTRIES: ["Luxembourg", "Belgium", "Netherlands"],

  //----- COLLECTION REFERENCES -----------------------------------------------------------------------
  COLLECTION: {
    USERS: "users",
    MARKERS: "markers",
    CREATED_MARKERS: "createdMarkers",
    MARKERS_CATEGORY: "markersCategory",
    LIBRARY: "library",
    CATEGORIES: "categories",
    CLASS_ICONS: "classIcons",
    ITINERARIES: "itineraries",

    REQUESTS: "requests",
    ANIMATIONS: "animations",
    GROUPS: "groups",
    STORES: "stores",
    BA_FORMS: "baForms",
    GROUP_FORMS: "groupForms",
    WEEKLY_REPORTS: "weeklyReports",

    CLAIMS_PROCESS: "process",
    WATCHES: "watches",
    WATCH_CATALOG: "watchCatalog",
    SERVICE_CATALOG: "serviceCatalogue",
    APPOINTMENTS: "appointments",
    WARRANTIES: "warranties",
    HISTORY: "history",
    NEWS: "news",
    NEWS_CATEGORIES: "newsCategories",
    PRODUCTS: "products",
    EMAILS: "emails",

    // SUBCOLLECTIONS
    CHECKOUT_SESSION: "checkout_sessions",
    PRICES: "prices",
    PAYMENTS: "payments",
    // collection("products").doc("tax_rates").collection("tax_rates")
    TAX_RATES: "tax_rates",
  },

  // database/auth fields
  FIELD: {
    PERMISSIONS: "permissions",
    MEMBER: "member",
    OWNER: "owner",
    PRESS: "press",
    ADMIN: "admin",
  },

  PRODUCT_PREFIX: "prod_",

  //----- FILTERS FOR LISTS -----------------------------------------------------------------------

  FILTER_TYPE: {
    SELECTION: 0,
    MULTI_SELECTION: 1,
    DATE: 2,
    NUMBER_RANGE: 3,
  },

  //------- EMAILS --------- -----------------------------------------------------------------------
  EMAIL_TYPE: {
    VERIFY: "verification",
    DELIVERY_REQUIREMENT: "deliveryRequirement",
  },

  CONTACT_TYPE: {
    EMAIL: 0,
    PHONE: 1,
    WHATSAPP: 2,
  },

  // templates
  // EMAIL_VERIFICATION: {
  //   type: VERIFY,
  //   press: false, // only needs to be set to differntiate special email verification mail for press
  //   actionLink: "", // CLUB_URL
  //   email: "" // auth.currentUser.email
  // }
  // EMAIL_VERIFICATION: {
  //   type: DELIVERY_REQUIREMENT,
  //   userId: auth.currentUser.uid,
  //   email: auth.currentUser.email
  //   countryCode: "LU",
  //   contact: CONTACT_TYPE.EMAIL,
  // }
};
